import Vue from 'vue';
import App from './polo-app.vue';

new Vue({ render: createElement => createElement(App) }).$mount('#app');